import {
  IMAGE_ASSIST_PENDING,
  IMAGE_ASSIST_FULFILLED,
  IMAGE_ASSIST_FAILED,
  IMAGE_ASSIST_CLEAR,
  IMAGE_ASSIST_APPLIED,
} from '../actions/actionTypes';

const initialState = {
  status: 'IDLE',
  analysisResult: null,
  applied: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case IMAGE_ASSIST_PENDING:
    return { ...state, status: 'LOADING', error: null };

  case IMAGE_ASSIST_FULFILLED:
    return {
      ...state,
      status: 'SUCCESS',
      analysisResult: action.payload,
      applied: false,
      error: null,
    };

  case IMAGE_ASSIST_FAILED:
    return { ...state, status: 'ERROR', error: action.payload };

  case IMAGE_ASSIST_APPLIED:
    return { ...state, applied: true };

  case IMAGE_ASSIST_CLEAR:
    return { ...initialState };

  default:
    return state;
  }
};
